import React from 'react';
import cx from 'classnames';
import isEmpty from 'lodash/isEmpty';

const FlexContainer = ({ children, className }) => (
    <div className={cx("flex-container", className)}>
        {children}
    </div>
);

const LeftColumn = ({ className, backgroundImage = null, children }) => {
    let props = {
        className: cx("flex-col-left", className)
    };

    if (!isEmpty(backgroundImage)) {
        props.style = {
            backgroundImage: `url("${backgroundImage}")`
        };
    }

    return (
        <div {...props}>
            <div className="inner">
                {children}
            </div>
        </div>
    );
};

const LeftColumnTitle = ({ children }) =>
    <h1 className="col-left-title">{children}</h1>
;

const RightColumn = ({ children, className }) =>
    <div className={cx("flex-col-right", className)}>
        <div className="inner">
            {children}
        </div>
    </div>
;

const RightColumnTitle = ({ children }) =>
    <h1 className="col-right-title">{children}</h1>
;

const RightColumnSubTitle = ({ children }) =>
    <h2 className="col-right-subtitle">{children}</h2>
;

export {
    LeftColumn,
    LeftColumnTitle,
    RightColumn,
    RightColumnTitle,
    RightColumnSubTitle
};

export default FlexContainer;
